// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Form, Input, Select, Button, message, Spin, Row, Col } from 'antd';
// import API_BASE_URL from '../../config/api';

// const { Option } = Select;
// const { TextArea } = Input;

// const ContactForm = ({ contact, onClose, onSubmit }) => {
//   const [form] = Form.useForm();
//   const [contactBunches, setContactBunches] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);

//   useEffect(() => {
//     fetchContactBunches();
//     if (contact) {
//       form.setFieldsValue({
//         name: contact.first_name,
//         email: contact.email || '',
//         phone: contact.phone || '',
//         address: contact.address || '',
//         // language: contact.language || 'en',
//         notes: contact.notes || '',
//         contactBunchId: contact.contact_bunch_id || undefined
//       });
//     }
//   }, [contact, form]);

//   const fetchContactBunches = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const response = await axios.get(`${API_BASE_URL}/contact-bunches`, {
//         headers: { Authorization: token }
//       });
//       setContactBunches(response.data);
//     } catch (err) {
//       console.error('Failed to fetch contact bunches:', err);
//       message.error('Failed to load contact bunches');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (values) => {
//     try {
//       setSubmitting(true);
//       const token = localStorage.getItem('token');
//       const contactData = {
//         name: values.name,
//         email: values.email,
//         phone: values.phone,
//         address: values.address,
//         // language: values.language,
//         notes: values.notes,
//         contact_bunch_id: values.contactBunchId || null
//       };

//       if (contact) {
//         await axios.put(`${API_BASE_URL}/contacts/${contact.id}`, contactData, {
//           headers: { Authorization: token }
//         });
//         message.success('Contact updated successfully');
//       } else {
//         await axios.post(`${API_BASE_URL}/contacts`, contactData, {
//           headers: { Authorization: token }
//         });
//         message.success('Contact created successfully');
//       }

//       form.resetFields();
//       onSubmit();
//     } catch (err) {
//       message.error(err.response?.data?.message || 'An error occurred');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleCancel = () => {
//     form.resetFields();
//     onClose();
//   };

//   return (
//     <Spin spinning={loading}>
//       <Form
//         form={form}
//         layout="vertical"
//         onFinish={handleSubmit}
//         initialValues={{
//           // language: 'en'
//         }}
//       >
//         <Row gutter={16}>
//           <Col xs={24} sm={12}>
//             <Form.Item
//               label="Name"
//               name="name"
//               rules={[{ required: true, message: 'Please enter name' }]}
//             >
//               <Input placeholder="Enter contact name" />
//             </Form.Item>
//           </Col>
          
//           <Col xs={24} sm={12}>
//           <Form.Item
//   label="Phone"
//   name="phone"
//   rules={[
//     { required: true, message: 'Please enter phone number' },
//     {
//       pattern: /^\+91\d{10}$/,
//       message: 'Please enter a valid 10-digit phone number with +91',
//     },
//   ]}
// >
//   <Input
//     placeholder="+91XXXXXXXXXX"
//     maxLength={13} 
//     onChange={(e) => {
//       let value = e.target.value;

//       if (!value.startsWith('+91')) {
//         value = '+91' + value.replace(/^\+91?/, '');
//       }

//       value = '+91' + value.slice(3).replace(/\D/g, '');

//       form.setFieldsValue({ phone: value });
//     }}
//   />
// </Form.Item>

//           </Col>
//         </Row>

//         <Row gutter={16}>
//           <Col xs={24} sm={12}>
//             <Form.Item
//               label="Email"
//               name="email"
//               rules={[{ type: 'email', message: 'Please enter valid email' }]}
//             >
//               <Input placeholder="Enter email address" />
//             </Form.Item>
//           </Col>
          
//           <Col xs={24} sm={12}>
//             {/* {
//             <Form.Item
//               label="Language"
//               name="language"
//             >
//               <Select placeholder="Select language">
//                 <Option value="en">English</Option>
//                 <Option value="ta">Tamil</Option>
//                 <Option value="hi">Hindi</Option>
//                 <Option value="ml">Malayalam</Option>
//                 <Option value="te">Telugu</Option>
//                 <Option value="kn">Kannada</Option>
//               </Select>
//             </Form.Item>
//             } */}
//           </Col>
//         </Row>

//         <Row gutter={16}>
//           <Col xs={24} sm={12}>
//             <Form.Item
//               label="Contact Bunch"
//               name="contactBunchId"
//               rules={[{ required: true, message: 'Please select a contact bunch' }]}
//             >
//               <Select 
//                 placeholder="Select a bunch"
//                 loading={loading}
//                 allowClear
//               >
//                 {contactBunches.map((bunch) => (
//                   <Option key={bunch.id} value={bunch.id}>
//                     {bunch.name}
//                   </Option>
//                 ))}
//               </Select>
//             </Form.Item>
//           </Col>
//         </Row>

//         <Row gutter={16}>
//           <Col span={24}>
//             <Form.Item
//               label="Address"
//               name="address"
//             >
//               <TextArea 
//                 rows={3} 
//                 placeholder="Enter customer address"
//               />
//             </Form.Item>
//           </Col>
//         </Row>

//         <Row gutter={16}>
//           <Col span={24}>
//             <Form.Item
//               label="Notes"
//               name="notes"
//             >
//               <TextArea 
//                 rows={3} 
//                 placeholder="Additional notes about the customer"
//               />
//             </Form.Item>
//           </Col>
//         </Row>

//         <Row gutter={16} style={{ marginTop: 24 }}>
//           <Col span={24}>
//             <Form.Item>
//               <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
//                 <Button onClick={handleCancel}>
//                   Cancel
//                 </Button>
//                 <Button 
//                   type="primary" 
//                   htmlType="submit" 
//                   loading={submitting}
//                 >
//                   {contact ? 'Update Contact' : 'Add Contact'}
//                 </Button>
//               </div>
//             </Form.Item>
//           </Col>
//         </Row>
//       </Form>
//     </Spin>
//   );
// };

// export default ContactForm;


import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../config/api";
import { message } from "antd"; // you can replace this with toast if you want

const ContactFormModal = ({ showForm, setShowForm, contact, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    notes: "",
    contactBunchId: "",
  });
  const [contactBunches, setContactBunches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchContactBunches();

    if (contact) {
      setFormData({
        name: contact.first_name || "",
        phone: contact.phone || "",
        email: contact.email || "",
        address: contact.address || "",
        notes: contact.notes || "",
        contactBunchId: contact.contact_bunch_id || "",
      });
    } else {
      resetForm();
    }
  }, [contact]);

  const fetchContactBunches = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_BASE_URL}/contact-bunches`, {
        headers: { Authorization: token },
      });
      setContactBunches(response.data);
    } catch (err) {
      message.error("Failed to load contact bunches");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      phone: "",
      email: "",
      address: "",
      notes: "",
      contactBunchId: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // enforce +91 phone format
    if (name === "phone") {
      let formatted = value;
      if (!formatted.startsWith("+91")) {
        formatted = "+91" + formatted.replace(/^\+91?/, "");
      }
      formatted = "+91" + formatted.slice(3).replace(/\D/g, "");
      setFormData((prev) => ({ ...prev, phone: formatted }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const token = localStorage.getItem("token");

      const contactData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        notes: formData.notes,
        contact_bunch_id: formData.contactBunchId || null,
      };

      if (contact) {
        await axios.put(`${API_BASE_URL}/contacts/${contact.id}`, contactData, {
          headers: { Authorization: token },
        });
        message.success("Contact updated successfully");
      } else {
        await axios.post(`${API_BASE_URL}/contacts`, contactData, {
          headers: { Authorization: token },
        });
        message.success("Contact created successfully");
      }

      resetForm();
      setShowForm(false);
      onSubmit();
    } catch (err) {
      message.error(err.response?.data?.message || "An error occurred");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    resetForm();
    setShowForm(false);
  };

  return (
    <div
      className={`modal fade ${showForm ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">
              {contact ? "Edit Contact" : "Add Contact"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCancel}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body modal-body-scroll">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Name */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                {/* Phone */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="+91XXXXXXXXXX"
                    required
                  />
                </div>

                {/* Email */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter email address"
                  />
                </div>

                {/* Contact Bunch */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Contact Bunch</label>
                  <select
                    className="form-select"
                    name="contactBunchId"
                    value={formData.contactBunchId}
                    onChange={handleInputChange}
                    required
                    disabled={loading}
                  >
                    <option value="">Select a bunch</option>
                    {contactBunches.map((bunch) => (
                      <option key={bunch.id} value={bunch.id}>
                        {bunch.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Address */}
                <div className="col-12 mb-3">
                  <label className="form-label">Address</label>
                  <textarea
                    className="form-control"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    rows="2"
                  />
                </div>

                {/* Notes */}
                <div className="col-12 mb-3">
                  <label className="form-label">Notes</label>
                  <textarea
                    className="form-control"
                    name="notes"
                    value={formData.notes}
                    onChange={handleInputChange}
                    rows="2"
                  />
                </div>
              </div>
            </form>
          </div>

          {/* Footer */}
          <div className="modal-footer d-flex justify-content-end gap-3 p-3">
            <button
              type="button"
              className="btn bg-danger-subtle text-danger px-4"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={handleSubmit}
              disabled={submitting}
            >
              {submitting
                ? "Saving..."
                : contact
                ? "Update Contact"
                : "Save Contact"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactFormModal;
